import React from 'react';
import { Section, SectionHead, Card, CardText, CardList } from './primitives';

const GROUPS = [
  {
    title: 'Your models',
    body: 'Point the agents at whatever you already pay for, or at nothing external at all.',
    items: [
      'OpenAI, Anthropic, Google, Together, and OpenAI-compatible endpoints',
      'Self-hosted open-weight models on your own GPUs',
      'Per-tier model routing, so cost follows plan value',
    ],
  },
  {
    title: 'Your identity',
    body: 'The install should look like your product, because it is.',
    items: [
      'Logo, palette, typography, domain, and transactional email',
      'Your terms of service, privacy policy, and disclaimers',
      'Your own docs site, or a rebranded copy of ours',
    ],
  },
  {
    title: 'Your data',
    body: 'The audit trail lives with you and stays with you.',
    items: [
      'Your database, your backups, your retention policy',
      'Full reasoning trace stored for every recommendation and order',
      'Export anything, any time — no proprietary storage format',
    ],
  },
  {
    title: 'Your agents',
    body: 'Katbot is the recommendation and execution substrate; the orchestration is yours to extend.',
    items: [
      'Framework-agnostic: OpenClaw, Claude Code, LangChain, PydanticAI, or your own',
      'MCP server and REST API for external agents',
      'Custom prompts, personas, scoring weights, and strategy packs',
    ],
  },
];

export const BringYourOwn = () => (
  <Section id="control">
    <SectionHead eyebrow="Bring your own everything" title="No lock-in you didn't choose." />
    <div className="grid gap-[18px] md:grid-cols-2">
      {GROUPS.map((g) => (
        <Card key={g.title} title={g.title}>
          <CardText>{g.body}</CardText>
          <CardList items={g.items} />
        </Card>
      ))}
    </div>
  </Section>
);

export default BringYourOwn;
